import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Layout route para /dashboard/$dashboardId/marketing
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing',
)({
  component: function MarketingLayoutRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <ProtectedRoute
        capability={CAPABILITIES.MARKETING_ALL}
        dashboardId={dashboardId}
      >
        <Outlet />
      </ProtectedRoute>
    )
  },
})
